<!-- Exlcusive Deals Start-->
<section class="section exlcusive_deals">
  <div class="container">
    <div class="home_heading">
      <div class="left">
        <h2 class="">Exclusive <strong>Deals</strong></h2>
        
    </div>
    </div>
    <div class="owl-carousel owl-theme banner">
      <div class="item" *ngFor="let ed of exclusiveDeals">
        <div class="card">
          <div class="imgsection"> <img class="card-img-top highttt" src={{ed.ImageURL}} alt="{{ed.Title}}">
          </div>
          <div class="card-body">
            <div class="label">
              <p>{{ed.Title}}</p>
            </div>
            <div class="itemDesc">
              <h5 class="card-title">{{ed.Heading}}</h5>
              <p>{{ed.Description}}</p>
            </div>
            <div class="bookingsection">
              <a href="{{ed.ExternalURL}}" target="_blank">Book Now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Exlcusive Deals End-->

<!-- Trending Cruise Itinerary start-->
<section class="section">
  <div class="container">
    <div class="home_heading">
      <div class="left">
        <h2 class="">Trending <strong>Cruise Itinerary</strong></h2>
      </div>
      <!-- <div class="right"><a href="" class="link">View All Packages</a></div> -->
    </div>
    <div class="owl-carousel owl-theme trending_cruise">
      <div class="item" *ngFor="let ic of trendingCruises">
        <div class="card"> <img class="card-img-top highttt" src={{ic.ImageURL}} alt="{{ic.FriendlyCruiseName}}">
          <div class="card-body"> <span>{{ic.storyCount}}</span>
            <div class="bottom">
              <h5 class="card-title"><a (click)="getCruiseDetails(ic.CruiseLine,'trending')">{{ic.CruiseLine}}</a></h5>
              <p class="card-text">Starting @ <strong>₹ {{ic.price | number}}</strong></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Trending Cruise Itinerary End-->

<div class="gray_background">

  <!-- International Cruise Start-->
  <section class="section">
    <div class="container">
      <div class="home_heading">
        <div class="left">
          <h2 class="">International <strong>Cruise</strong></h2>
          <div class="menulist">
          <ul class="slider_list_menu">
            <li *ngFor="let heading of internationHeading; let i = index" [ngClass]="activeContinent==heading.heading?'active':''">
              <a (click)="getInternationalCruise('continent',heading.heading,'')">{{heading.heading}}</a></li>
          </ul>
        </div>
      </div>
        <!-- <div class="right"><a href="" class="link">View All Packages</a></div> -->
      </div>

      <div class="owl-carousel owl-theme cruise-bottom-slider" id="internationaCruise">
        <div class="item" *ngFor="let ic of internationaCruises">
          <div class="card"> <img class="card-img-top highttt" src={{ic.ImageURL}} alt="{{ic.FriendlyCruiseName}}">
            <div class="card-body">
              <h2>{{ic.FriendlyCruiseName}}<span>{{ic.Nights}}</span></h2>
              <div class="footer">
                <h3>Starting Price<span>₹ {{ic.StartPrice | number}}</span></h3>
                <a (click)="getCruiseDetails(ic.CruiseCode,'international')">Details</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- International Cruise end -->

  <!-- Domestic Cruise Start -->
  <section class="section">
    <div class="container">
      <div class="home_heading">
        <div class="left">
          <h2 class="">Domestic <strong>Cruise</strong></h2>
          <div class="menulist">
          <ul class="slider_list_menu">
            <li class="active">Indian Subcontinent</li>
          </ul>
        </div>
      </div>
      </div>
      
      <div class="owl-carousel owl-theme bottom-slider cruise-bottom-slider" id="domesticcarousel">
        <div class="item" *ngFor="let ic of domecticCruises">
          <div class="card"> <img class="card-img-top highttt" src={{ic.ImageURL}} alt="{{ic.FriendlyCruiseName}}">
            <div class="card-body">
              <h2>{{ic.FriendlyCruiseName}}<span>{{ic.Nights}}</span></h2>
              <div class="footer">
                <h3>Starting Price<span>₹ {{ic.StartPrice | number}}</span></h3>
                <a (click)="getCruiseDetails(ic.CruiseCode,'domestic')">Details</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Domestic Cruise end -->

  <!-- Cruise Line Start -->
  <section class="section">
    <div class="container">
      <div class="home_heading">
        <div class="left">
           <h2 class="">Cruise <strong>Line</strong></h2>
          <div class="menulist">
          <ul class="slider_list_menu">
            <li *ngFor="let heading of cruiselineHeading; let i = index" [ngClass]="activeCruiseLine==heading.heading?'active':''">
              <a (click)="getcruiselineCruise('cruise',heading.heading)">{{heading.heading.split(' ')[0]}}</a>
            </li>
              </ul>
        </div>
      </div>
        <!-- <div class="right"><a href="" class="link">View All Packages</a></div> -->
      </div>

      <div class="owl-carousel owl-theme bottom-slider cruise-bottom-slider" id="cruiselinecarousel">
        <div class="item" *ngFor="let ic of cruiselineCruises">
          <div class="card"> <img class="card-img-top highttt" src={{ic.ImageURL}} alt="{{ic.FriendlyCruiseName}}">
            <div class="card-body">
              <h2>{{ic.FriendlyCruiseName}}<span>{{ic.Nights}}</span></h2>
              <div class="footer">
                <h3>Starting Price<span>₹ {{ic.StartPrice | number}}</span></h3>
                <a (click)="getCruiseDetails(ic.CruiseCode,'cruiseline')">Details</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Cruise Line end -->
  <section class="section">
    <div class="container">
      <div class="home_heading">
        <div class="left">
          <h2 class="">Available <strong>Offers</strong></h2>
          <div class="menulist">
            <ul class="slider_list_menu">
              <li *ngFor="let heading of cruiseMonths; let i = index"
                [ngClass]="activeContinent==heading.month?'active':''">
                <a (click)="getcruiselineOffers(heading.month,'get')">{{heading.month}}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="owl-carousel owl-theme cruise-bottom-slider" id="cruiseOffer">
        <div class="item" *ngFor="let ic of cruiseOffers">
          <div class="card"> <img class="card-img-top highttt" src={{ic.imageURL}} alt="{{ic.CruiseName}}">
            <div class="card-body">
              <!-- <h2>{{ic.CruiseName}}</h2> -->
              <h2><a class=" mr-1  red" data-toggle="modal" data-target="#offersdata" href="#"
                (click)="getOffers(ic)" title="Available Offers">{{ic.CruiseName}}</a> </h2>
              <div class="footer">
                <h3>Sailing<span>{{ic.SailingDate}}</span></h3>
                <a (click)="getCruiseDetails(ic.CruiseCode,'international')">Details</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div id="offersdata" class="modal fade send-query-popup" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content p-sm-3">
            <div class="modal-body">
                <button type="button" id="leadModal" class="close" data-dismiss="modal" aria-label="Close"> <span
                        aria-hidden="true">&times;</span></button>
                <div class="text-center">
                    <h2>Available Offers</h2>
                </div>
                <div class="col-md-12 col-sm-12 col-xs-12 mt-4  row">
                    <div class=" col-md-6 col-sm-6 col-xs-6 mt-2 mb-2" *ngFor="let Offers of Cruisedata.cabinOffers">
                        <h5 class="text-3 mb-2 mt-2 ">{{Offers.cabin}}</h5>
                        <div class="text-2 mb-2" *ngIf="Offers.cabinupgrade.upgradetext!=''"><b>Upgrade:</b> {{Offers.cabinupgrade.upgradetext}} </div>
                        <div class="text-2 mb-2" *ngIf="Offers.onboardoffer!=''"><b>Onboard:</b> {{Offers.onboardoffer}}
                        </div>
                        <div class="text-2 mb-2" *ngIf="Offers.partpayment.partoffer!=''"><b>Payment:</b> {{Offers.partpayment.partoffer}} </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
  <!-- Travel Stories Start-->
  <section class="section">
    <div class="container" *ngIf="loginType != 'B2B'">
      <div class="home_heading">
        <div class="left">
          <h2 class="">Travel <strong>Stories</strong></h2>
        </div>
      </div>
      <div class="owl-carousel owl-theme travel-stories">
        <div class="item" *ngFor="let ic of travelstoriesCruises">
          <div class="card"> <img class="card-img-top" src={{ic.ImageURL}} alt="{{ic.Title}}">
            <div class="content-area">
              <p>Experiences</p>
              <div class="bottom">
                <!-- <h3>11/12/2019</h3> -->
                <h4>{{ic.Title}}</h4>
                <h5>{{ic.Description}}</h5>
                <a href="{{ic.ExternalURL}}" target="_blank">Read More</a>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </section>
  <!-- Travel Stories End-->
</div>